import React, { Component } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './ImportAsscClienteEmpresa.css'
import {
  Btn,
  ExcelModeloBuilder,
  ImportExcelFile,
  PageHeader,
  SelectEmpresas,
  TextBtn,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as SystemHttp from '../../../../services/api/https/system/system.http'

// const REGEX_TO_MATCH_SPECIAL_CHARACTERS = /[^a-zA-Z0-9 ]/g

class ImportAsscClienteEmpresa extends Component {
  modeloExcel = [['cnpj_do_cliente_sem_ponto', 'codigo_do_cliente_na_empresa']]
  state = {
    loading: true,
    associacoes: [],
    company_id: null,
  }
  onEmpresaChange = value => {
    try {
      const { id } = value
      this.setState({ company_id: id })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  onBtnSalvarClicked = async () => {
    try {
      this.setState({ loading: true })
      const { associacoes } = this.state
      if (associacoes.length === 0) {
        throw new Error('Não existem Associações para Importação')
      }
      const message = await SystemHttp.saveAssocClienteEmpresa(associacoes)
      this.props.dispatch(showMessageBox(message, null))
      this.setState({ loading: false, associacoes: [] })
    } catch (error) {
      this.setState({ loading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  onBtnVoltarClicked = () => {
    this.props.history.goBack()
  }
  onFileImported = content => {
    try {
      const isPlanilhaNoPadrao = this._planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      if (!this.state.company_id) {
        throw new Error('Selecione uma empresa e tente novamente.')
      }
      this.setState({ associacoes: this._buildAssociacoes(content) })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error.message))
    }
  }
  render() {
    return (
      <div>
        <PageHeader>
          <span>S.10 - Importação Associação Cliente x Empresa</span>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <Panel>
            <div className="p-grid">
              <div className="p-col-3">
                <SelectEmpresas
                  companyId={this.state.company_id}
                  onChange={value => this.onEmpresaChange(value)}
                />
              </div>
              <div className="p-col-9" style={{ paddingTop: 35 }}>
                <ExcelModeloBuilder
                  modeloColunas={this.modeloExcel}
                  filename="ImportaoAssocClienteEmpresa.xlsx"
                />
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <ImportExcelFile
                    label="Importar"
                    classes="btnImportar"
                    onFileImported={this.onFileImported}
                  />
                </div>
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
                </div>
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <TextBtn onClick={this.onBtnVoltarClicked}>Voltar</TextBtn>
                </div>
              </div>
            </div>
            <div>
              <DataTable value={this.state.associacoes} emptyMessage="Nenhum cliente importado">
                <Column field="cnpj" header="CNPJ do Cliente" style={tableCellCentered()} />
                <Column
                  field="company_code"
                  header="Código do Cliente na Empresa"
                  style={tableCellCentered()}
                />
              </DataTable>
            </div>
          </Panel>
        </div>
      </div>
    )
  }
  // Helpers
  _planilhaNoPadrao = content => {
    const header = content[0]
    return header[0] === 'cnpj_do_cliente_sem_ponto' && header[1] === 'codigo_do_cliente_na_empresa'
  }
  _buildAssociacoes = content => {
    const body = content.splice(1)

    return body
      .filter(row => Array.isArray(row) && row.length > 0)
      .map(row => {
        return {
          company_id: this.state.company_id,
          cnpj: ('000' + row[0].toString()).slice(-14),
          company_code: row[1],
          actived: true,
        }
      })
  }
}
export default connect()(withRouter(ImportAsscClienteEmpresa))
